import {AfterViewInit, Component} from '@angular/core';
import {ReserveSelectDateFormFragmentController} from './ReserveSelectDateFormFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {MstDoctorDTOInterface} from '../../../../../../../DTO/MstDoctorDTOInterface';
import {ReserveSelectTimePopoverComponent} from './ReserveSelectTime/ReserveSelectTimePopoverComponent';
import {ReservationSaveDTOInterface} from '../../../../../../../DTO/ReservationSaveDTOInterface';
import {ReservationFrameDayDTOInterface} from '../../../../../../../DTO/ReservationFrameDayDTOInterface';
import {MatSelectChange} from '@angular/material/select';
import {DateUtil} from '../../../../../../../Util/DateUtil';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './ReserveSelectDateFormFragmentComponent.html',
	styleUrls: ['../ReserveCreateFormLayout.scss', './ReserveSelectDateFormFragmentComponent.scss'],
})

/**
 * 予約日時選択
 */
export class ReserveSelectDateFormFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: ReserveSelectDateFormFragmentController;

	// 親から設定されるデータ
	public eventConfirmDate: (reserve: ReservationSaveDTOInterface) => void;
	public eventStart: (reserve: ReservationSaveDTOInterface) => void;
	public eventSetReserveSaveData: (reserve: ReservationSaveDTOInterface) => void;

	// スピナーの設定
	public colorVal: ThemePalette = 'primary';
	public modeVal: ProgressSpinnerMode = 'indeterminate'; // 'determinate';
	public valueVal = 50; // determinate だと、この値を変える事で、プログレスバーみたいに動くはず

	public isLoading = true;

	// 予約内容
	public reserveModel: ReservationSaveDTOInterface = {} as ReservationSaveDTOInterface;

	// 表示開始日
	public startDate = new Date();

	// 取得日数
	public getDayNumber = 7;

	// 選択日
	public selectedDay: ReservationFrameDayDTOInterface;

	// 選択可能な医師(選択されている診療科に属する医師)
	private initialDoctorList: Array<MstDoctorDTOInterface> = [
		{id: 0, clinicId: 0, name: 'すべての医師'},
	];
	public doctorList: Array<MstDoctorDTOInterface> = [
	];

	// 予約日リスト
	public dayList = [];

	// 選択日時表示用
	public reserveDate = '';

	// 時間が選択されているかのチェック
	public isSelectedTime = false;

	// 表示開始日と取得データの開始日
	// ページ判定で利用する
	public startDayYMD = '';
	public firstDayYMD = '';
	public isFirstPage = true;
	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(ReserveSelectDateFormFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
	}


	/**
	 * 開始処理
	 */
	public async start() {
		const initialData = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getInitialData.bind(this),
			{view: this, reserve: this.reserveModel, startDate: this.startDate, count: this.getDayNumber}
		);
		// 表示開始日
		this.startDayYMD = DateUtil.getNowDateString();
		await this.setDayList(initialData.data);
		this.doctorList = [...this.initialDoctorList, ...initialData.doctorList];
		await this.closeSpinner();
	}


	/**
	 *
	 * @param dayData
	 */
	public async setDayList(dayData): Promise<void> {
		const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];

		const keys = Object.keys(dayData);
		const dayList = [];
		for (let i = 0; i < keys.length; i += 7) {
			const days = [];

			for (let j = 0; j < 7 && i + j < keys.length; j++) {
				if (i === 0 && j === 0) {
					this.firstDayYMD = dayData[keys[i + j]].date;
				}
				dayData[keys[i + j]].dayOfWeekName = dayOfWeek[dayData[keys[i + j]].dayOfWeek];
				days.push(dayData[keys[i + j]]);
			}
			dayList.push(days);
		}
		this.dayList = dayList;


		// 最初のページのチェック
		if (this.firstDayYMD === this.startDayYMD) {
			this.isFirstPage = true;
		} else {
			this.isFirstPage = false;
		}
	}


	/**
	 * 時間選択画面の表示
	 * @param day
	 */
	public async openSelectTimePopover(day: ReservationFrameDayDTOInterface) {

		if (day.count === 0) {
			return;
		}

		this.selectedDay = day;
		await this.showDialogWindow(
			ReserveSelectTimePopoverComponent,
			{
				day,
				onSelectTime: this.onSelectTime.bind(this),
				close: this.dismissDialogWindow.bind(this),
			}
		);
	}

	/**
	 * 確認画面の表示
	 */
	public async confirm() {
		if (this.isSelectedTime === false) {
			this.showAlertDialog('エラー', '予約日時を選択してください');
			return;
		}
		await this.eventConfirmDate(this.reserveModel);
	}

	/**
	 * 初期画面に戻る
	 */
	public async cancel() {
		this.reserveModel.reservationDate = '';
		this.reserveModel.reservationFrom = '';
		this.reserveModel.reservationTo = '';

		await this.eventStart(this.reserveModel);
	}

	/**
	 * 時間選択時のコールバック
	 * @param time
	 */
	public async onSelectTime(time) {
		// 画面表示用
		this.reserveDate = `${this.selectedDay.year}年${this.selectedDay.month}月${this.selectedDay.day}日`;

		// 予約データにセット
		this.reserveModel.reservationDate = `${this.selectedDay.year}-${this.selectedDay.month}-${this.selectedDay.day}`;
		this.reserveModel.reservationFrom = time.start;
		this.reserveModel.reservationTo = time.end;

		await this.eventConfirmDate(this.reserveModel);
	}


	/**
	 * select選択時のコールバック
	 * @param event
	 * @param name
	 */
	public async onSelectionChange(event: MatSelectChange, name: string): Promise<void> {

		switch (name) {
			case 'doctor':
				await this.showSpinner();
				// 医師変更
				const fetchData = await this.execFuncWithErrorHandling(
					this,
					await this.combineCtrl.getInitialData.bind(this),
					{view: this, reserve: this.reserveModel, startDate: this.startDate, count: this.getDayNumber}
				);

				await this.setDayList(fetchData.data);

				// 選択済みの日時をリセット
				this.reserveModel.reservationDate = '';
				this.reserveModel.reservationFrom = '';
				this.reserveModel.reservationTo = '';
				this.isSelectedTime = false;
				await this.closeSpinner();
				break;

		}
	}

	/**
	 * 次の日時データの取得
	 */
	public async nextDate(): Promise<void> {
		await this.showSpinner();
		const nextDate = this.startDate.getDate() + this.getDayNumber;
		this.startDate = new Date(this.startDate.setDate(nextDate));
		const initialData = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getInitialData.bind(this),
			{view: this, reserve: this.reserveModel, startDate: this.startDate, count: this.getDayNumber}
		);

		await this.setDayList(initialData.data);
		this.doctorList = [...this.initialDoctorList, ...initialData.doctorList];
		await this.closeSpinner();
	}

	/**
	 * 前の日時データの取得
	 */
	public async prevDate(): Promise<void> {
		await this.showSpinner();
		const prevDate = this.startDate.getDate() - this.getDayNumber;
		this.startDate = new Date(this.startDate.setDate(prevDate));
		const initialData = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getInitialData.bind(this),
			{view: this, reserve: this.reserveModel, startDate: this.startDate, count: this.getDayNumber}
		);

		await this.setDayList(initialData.data);
		this.doctorList = [...this.initialDoctorList, ...initialData.doctorList];
		await this.closeSpinner();
	}

	public async showSpinner(): Promise<void> {
		this.isLoading = true;
	}
	public async closeSpinner(): Promise<void> {
		this.isLoading = false;
	}
}

